// Journal des envois de photos : sans trace cote tablette, un fichier jamais
// recu cote eKo ne se diagnostique qu'en relisant les logs du frontal. Les
// entrees sont persistees et consultables depuis la page Logs.
const MAX_ENTRIES = 200;

const store = {
	namespaced: true,
	state: {
		entries: [],
	},
	mutations: {
		add(state, entry) {
			// plus recent en tete : la page Logs lit de haut en bas
			state.entries.unshift(entry);
			if (state.entries.length > MAX_ENTRIES) {
				state.entries.splice(MAX_ENTRIES);
			}
		},
		clear(state) {
			state.entries = [];
		},
	},
	actions: {
		log({commit}, entry) {
			let line = {at: new Date().toISOString(), ...entry};
			console.log('journal', line);
			commit('add', line);
		},
		clear({commit}) {
			commit('clear');
		},
	},
	getters: {
		getAll: (state) => {
			return state.entries;
		},
		getByUid: (state) => (uid) => {
			return state.entries.filter((entry) => entry.uid === uid);
		},
	},
}

export default store
